// extracted by mini-css-extract-plugin
module.exports = {"button":"style__button__dikWq","notSupported":"style__notSupported__y0RB1","thumbnail":"style__thumbnail__0R-Uq","pdfIcon":"style__pdfIcon__LzbhK"};